
import React from "react";
import { Eye, Share2, Download, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface LetterActionsProps {
  letterId: string;
  onView: (id: string) => void;
  onShare: (id: string) => void;
  onDownload: (id: string) => void;
  onDelete: (id: string) => void;
}

export function LetterActions({ 
  letterId, 
  onView, 
  onShare, 
  onDownload, 
  onDelete 
}: LetterActionsProps) {
  return (
    <div className="flex justify-end gap-2">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onView(letterId)}
        className="h-8 w-8 hover:bg-blue-50 hover:text-blue-600"
      >
        <Eye className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onShare(letterId)}
        className="h-8 w-8 hover:bg-indigo-50 hover:text-indigo-600"
      >
        <Share2 className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onDownload(letterId)}
        className="h-8 w-8 hover:bg-green-50 hover:text-green-600"
      >
        <Download className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onDelete(letterId)}
        className="h-8 w-8 text-red-500 hover:text-red-700 hover:bg-red-50"
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
}
